import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SITES } from 'src/app/config/sites';
import LinkItem from 'src/app/definitions/LinkItem.interface';
import Offer from 'src/app/definitions/Offer.interface';
import { UtilService } from 'src/app/services/util.service';
import { DataService, OfferType } from './../../services/data.service';

export interface OfferField {
  label: string;
  value: string;
  id?: string;
}

export const DEFAULT_FIELDS = [
  'institution',
  'phone',
  'contact_email',
  'short_description',
  'place_detail',
  'municipalities_short',
  'price_formatted',
  'cancellation_policy',
  'price_detail',
  'duration_detail',
  'intensity',
  'entry_time',
  'internal_reference',
  'external_url',
  'external_url_2',
  'external_offer_url',
  'external_offer_url_2'
];

@Component({
  selector: 'app-offer-detail-body',
  templateUrl: './offer-detail-body.component.html',
  styleUrls: ['./offer-detail-body.component.scss']
})
export class OfferDetailBodyComponent implements OnInit, OnChanges {
  @Input() siteName: string;
  @Input() offer: Offer;
  @Input() offerType: OfferType;
  @Input() isPreview: boolean;
  offerFields: OfferField[] = [];
  linkFileds: LinkItem[];
  url: string;
  email: string;
  offerIndex: number;

  // offer pricings
  OFFER_DETAIL_ACCORDION_FIELDS: string[] = [];
  OFFER_DETAIL_ACCORDION_FIELDS_OTHER: string[] = [];
  OFFER_DETAIL_ACCORDION_COL_WIDTHS: string[] = [];
  OFFER_DETAIL_ATTRIBUTES: string[] = [];

  constructor(
    private router: Router,
    private utilService: UtilService,
    private translateService: TranslateService,
    public dataService: DataService
  ) {}

  ngOnChanges(): void {
    // just for spec
    if (this.offer) {
      this.buildFields();
    }
  }

  ngOnInit(): void {
    this.initSiteConfig();

    // just for spec
    if (this.offer) {
      this.buildFields();
    }
  }

  buildRegistrations(): void {
    this.offer.registrations = [
      {
        TITLE: this.translateService.instant('OFFER_DETAIL.REGISTRATION_OURS'),
        routerLink: `/booking/${this.utilService.getOfferDetailSlug(
          this.offer
        )}`
      }
    ];

    if (this.offer.registration) {
      this.offer.registrations.push({
        TITLE: this.translateService.instant(
          'OFFER_DETAIL.REGISTRATION_CLIENT'
        ),
        LINK: this.offer.registration,
        newWindow: true
      });
    }
  }

  buildFields(): void {
    this.buildRegistrations();

    this.OFFER_DETAIL_ATTRIBUTES.forEach((key) => {
      if (DEFAULT_FIELDS.includes(key) || this.hasAdditionalValue(key)) {
        if (key === 'intensity' && this.offer.hide_intensity) {
          return;
        }
        if (key === 'external_offer_url' && !this.offer[key]) {
          return;
        }
        this.offerFields.push({
          label: this.utilService.translateAttribute('offers', key),
          value:
            Array.isArray(this.offer[key]) && key !== 'registrations'
              ? this.offer[key].join(', ')
              : this.offer[key],
          id: key
        });
      }
    });
  }

  isEmail(value): boolean {
    if (typeof value === 'object') {
      if (value && value[0]) {
        value = value[0];
      } else {
        return false;
      }
    }
    const expressionEmail = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/gi;
    const regex = new RegExp(expressionEmail);
    this.email = value.match(regex);
    return !!this.email;
  }

  isUrl(value): boolean {
    if (typeof value === 'object') {
      if (value && value[0]) {
        value = value[0];
      } else {
        return false;
      }
    }
    const expressionUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    const regex = new RegExp(expressionUrl);
    this.url = value.match(regex);
    return !!this.url;
  }

  hasAdditionalValue(key: string): boolean {
    return Boolean(
      this.offerType.dropdown_fields.find((field) => field.field_name === key)
    );
  }

  private initSiteConfig(): void {
    this.OFFER_DETAIL_ATTRIBUTES =
      SITES[this.siteName].options.OFFER_DETAIL.ALLOWED_ATTRIBUTES;

    this.OFFER_DETAIL_ACCORDION_FIELDS =
      SITES[this.siteName].options.OFFER_DETAIL_ACCORDION.ALLOWED_COLUMNS;
    this.OFFER_DETAIL_ACCORDION_FIELDS_OTHER =
      SITES[this.siteName].options.OFFER_DETAIL_ACCORDION.ALLOWED_COLUMNS_OTHER;
    this.OFFER_DETAIL_ACCORDION_COL_WIDTHS =
      SITES[this.siteName].options.OFFER_DETAIL_ACCORDION.COL_WIDTHS;
  }
}
